import PropTypes from 'prop-types';
import HeaderCloseButton from 'core/modules/components/headers/HeaderCloseButton/HeaderCloseButton';
import React from 'react';

function HeaderCustom({ left = null, center = null, right = null, className = '', onClose = null }) {
  return (
    <div className={`header-custom ${className}`}>
      <div className="header-custom__grid">
        <div className="header-custom__left">{left}</div>
        <div className="header-custom__center">{center}</div>
        <div className="header-custom__right">
          {right}
          {onClose && <HeaderCloseButton onClick={onClose} />}
        </div>
      </div>
    </div>
  );
}

HeaderCustom.propTypes = {
  center: PropTypes.node,
  className: PropTypes.string,
  left: PropTypes.node,
  onClose: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  right: PropTypes.node,
};

export default HeaderCustom;
